import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { loginInterface } from 'app/Model/login.Interface';
import { DataApi } from 'app/Model/dataApi';
import { DataApiService } from 'app/services/data-api.service';
import { LoginService } from 'app/services/login.service';
import { ToastrServiceLocal } from 'app/services/toast/toastr.service';
import { MensajesHttpService } from 'app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class LoginPostulanteFacadeService {

  private loading$ = new BehaviorSubject<any>({ loading: false, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
  public responseLoading$: Observable<any> = this.loading$.asObservable();

  private error$ = new BehaviorSubject<any>({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
  public responseError$: Observable<any> = this.error$.asObservable();

  public cambioContraseña$ = new BehaviorSubject<any[]>([]);
  public responsecambioContraseña$: Observable<any[]> = this.cambioContraseña$.asObservable();

  constructor(private _loginService: LoginService, private _toast: ToastrServiceLocal,
    private _dataApi: DataApiService,
    private _mensajeHttp: MensajesHttpService, private _router: Router) { }

  // NOTA: 'login/loginPostulante' todavía no existe en el backend, es un endpoint
  // placeholder siguiendo el mismo patrón de login/loginDSA. Falta crearlo
  // (o definir a cuál SP/endpoint real debe apuntar) antes de que esto funcione.
  loginPostulante(params: any) {
    this.loading$.next({ loading: true, recurso: 'POST', message: 'Cargando Logueo', messages: [] });
    this.error$.next({ hasError: false, recurso: 'POST', messageError: '', errors: [] });
    const request$ = this._loginService.logueoLc('login/loginPostulanteDSA', params).pipe(
      tap((result: loginInterface | any) => {
        result?.user?.data?.Table0.forEach((item: any) => {
          if (item.hijos) { item.hijos = JSON.parse(item.hijos); }
        });
        localStorage.setItem("nombre", result?.user?.data?.Table1[0]?.nombre || '');
        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(result?.user.data.Table0), result?.token).toString();
        localStorage.setItem("MFX_01", encryptedData);
        localStorage.setItem(environment.tokenLocal, result?.token);
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
        this._toast.mensajeSuccess('Bienvenido al portal del Postulante', '');

        if (result?.user?.data?.Table1[0]?.logueo === true) {
          this._router.navigateByUrl('/postulante/cambioCredencial');
        } else {
          this._router.navigateByUrl('/postulacion/documentoPostulacion');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrió un error al loguearse', '');
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al loguearse', messages: [] });
        this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrió un error al loguearse'), errors: [] });
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  cambioCredencialPostulante(params: any): Observable<any> {
    this.loading$.next({ loading: true, recurso: 'POST', message: 'Cambiando contraseña', messages: [] });
    const request$ = this._dataApi.PostDataApi(`Solicitudes/updatePassword/postulante`, params).pipe(
      tap((result: DataApi | any) => {
        this.cambioContraseña$.next(result.data.Table0);
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Respuesta cargada', messages: [] });
      }),
      catchError((error: HttpErrorResponse) => {
        this._mensajeHttp.mostrarErrorHttp(error, 'Ocurrió un error al cambiar credenciales', '');
        this.loading$.next({ loading: false, recurso: 'POST', message: 'Error al cambiar credenciales', messages: [] });
        this.error$.next({ hasError: true, recurso: 'POST', messageError: this._mensajeHttp.mostrarErrorHttpString(error, 'Ocurrió un error al cambiar credenciales'), errors: [] });
        return EMPTY;
      })
    );

    return request$;
  }
}
